<template>
  <base-modal-component>
    <template v-slot:header>
      <h4 class="u-typography-color md-title">
        {{ createOrUpdate }} Custom Page
      </h4>
    </template>

    <template v-slot:body>
      <p
        v-if="error && error.messages"
        class="md-error"
      >
        {{ error.messages }}
      </p>
      <form
        novalidate
        @submit.prevent="validateUser"
      >
        <md-field :class="getValidationClass($v.customPage.name)">
          <label for="name">Name</label>
          <md-input
            v-model="customPage.name"
            v-focus
            name="name"
            type="name"
            class="md-input"
            autocomplete="off"
          />
          <span
            v-if="!$v.customPage.name.required"
            class="md-error"
          >The name is required</span>
        </md-field>
        <error-response-messages :field-name="'name'" />
      </form>
    </template>
    <template v-slot:footer>
      <div class="u-mr-xs">
        <generic-button
          variation="grey"
          @click="close"
        >
          Close
        </generic-button>
      </div>
      <div v-if="customPage.role === 2" class="u-mr-xs">
        <generic-button
          variation="red"
          @click="validateUser(true)"
        >
          Create and set permissions
        </generic-button>
      </div>
      <generic-button
        variation="red"
        @click="validateUser"
      >
        {{ createOrUpdate }}
      </generic-button>
    </template>
  </base-modal-component>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { required } from "vuelidate/lib/validators";
import { validationBaseMixin } from '../../../../../../mixins/ValidationBaseMixin'
import GenericButton from '../../../../../../shared/buttons/GenericButton'
import ErrorResponseMessages from '../../../../../../shared/error-response-messages/ErrorResponseMessages'
import BaseModalComponent from '../../../../../../shared/modal/BaseModalComponent'


export default {
  name: 'CreateCustomPageModal',
  components: {
    GenericButton,
    ErrorResponseMessages,
    BaseModalComponent
  },
  mixins: [validationBaseMixin],

  props: {
    customPage: {
      type: Object,
      required: true,
    },
    customPageId: {
      type: Number,
      required: false,
      default: null
    }
  },

  data() {
    return {
      messages: {
        error: null,
        success: null,
      },
    };
  },
  computed: {
    ...mapGetters("response", ["success", "error"]),

    createOrUpdate() {
      return !this.customPageId ? 'Create' : 'Update';
    },
  },

  validations: {
    customPage: {
      name: {
        required
      },
    },
  },

  methods: {
    ...mapActions("response", ["handleSuccess", "handleError", "resetError"]),
    ...mapActions("customPages", ["createCustomPage", "updateCustomPage"]),

    handleCreateCustomPage() {
      this.createCustomPage(this.customPage);
      this.close();
    },

    handleUpdateCustomPage() {
      this.updateCustomPage({ id: this.customPageId, updateData: this.customPage });
      this.close();
    },

    validateUser() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        !this.customPageId ? this.handleCreateCustomPage() : this.handleUpdateCustomPage();
      }
    },

    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
